import * as yup from 'yup';
import ModuleBootstrapper from '../common/ModuleBootstrapper/ModuleBootstrapper';
import Card from './models/Card';

const config =  {
    name: 'cards',
    actions: [
        { type: 'request', name: 'getAll' },
        { type: 'request', name: 'getOne' },
        { type: 'request', name: 'create' },
        { type: 'request', name: 'edit' },
        { type: 'request', name: 'delete' },
        { type: 'request', name: 'getCardGames'},
    ],
    endpoints: {
        cardGames: '/card-games',
        cards: '/card-games/cards',
        card: '/card-games/cards/[id]',
        resyncPrices: '/card-games/sync-prices',
        resyncPricesStatus: '/card-games/sync-prices/status'
    },
    defaults: {
        createCard: {

        }
    },
    validations: {
        card: yup.object().shape({

        })
    }
}

const Config ={
    Actions: ModuleBootstrapper.getActions(config.name, config.actions),
    Endpoints: config.endpoints,
    Defaults: config.defaults,
    Validations: config.validations,
    ...ModuleBootstrapper.getUtils(),
    Structures: {
        Card
    },
}

export default Config;
